import {
  ref,
  getDownloadURL,
  uploadBytes,
  getBlob,
  getMetadata,
  updateMetadata,
  deleteObject,
} from "firebase/storage";

async function firebaseDeleteFile(storageRef, files, setFiles) {
  // const targetUrl = `${process.env.CMS_URL}${file.url}`;

  // try {
  //   let a = document.createElement("a");
  //   document.body.appendChild(a);
  //   a.style = "display: none";
  //   a.href = targetUrl;
  //   a.target = "_blank";
  //   a.download = file.name;
  //   a.click();
  //   // window.URL.revokeObjectURL(url);
  // } catch (e) {
  //   console.log(e);
  // }
  try {
    // THIS IS HARD DELETE
    const resp = await deleteObject(storageRef);

    // const updatedFiles = files.filter((file) => {
    //   return file.name !== storageRef.name;
    // });

    // setFiles(updatedFiles);

    // BELOW IS A SOFT DELETE
    // but then I would have to get metadata of all files
    // and sort out soft deleted ones before presenting them in UI to user
    // this would have to be done on BE for speed purposes and
    // I would  have to create new endpoint with my own security rules

    // TODO Better approach is probably to enable versioning (https://cloud.google.com/storage/docs/using-object-versioning#set)
    // once versioning enabled, deletes will version, and listAll most likely will pull in latest I assume
    // const metadata = await getMetadata(storageRef);

    // const uCustomMetadata = {
    //   ...metadata.customMetadata, // Optional: Spread existing metadata if retrieved
    //   isDeleted: true,
    // };

    // const resp = await updateMetadata(storageRef, {
    //   customMetadata: uCustomMetadata,
    // });

    // const updatedFiles = files.filter((file) => {
    //   return file.name !== resp.name;
    // });

    // setFiles(updatedFiles);
  } catch (e) {
    console.log(e);
  }
}

export default firebaseDeleteFile;
